import type { Tokens } from '../../../theming/types'
import { styles } from '../../../utilities'
import { zIndexes } from '../../../variables'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        marginBottom: tokens.spacingGap200,
        zIndex: zIndexes.ToastMessage,
      },

      content: {
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        wordWrap: 'break-word',

        '& a': {
          color: 'inherit',
          textDecoration: 'underline',
        },
      },

      icon: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },

      body: {
        flex: '1 1 0%',
        minWidth: 0,
      },
    },

    visuallyHidden: {
      outerwrap: styles.visuallyHidden,
    },

    loading: {
      spinner: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },

    hidden: styles.visuallyHidden,

    motionVariants: {
      toastWrap: {
        initial: {
          opacity: 0,
        },

        enter: (toastHeight: number) => ({
          y: [-toastHeight, 0],
          opacity: 1,
          transition: {
            duration: 0.35,
          },
        }),

        exit: {
          opacity: 0,
          transition: {
            when: 'beforeChildren',
            duration: 0.25,
            ease: 'opacity',
          },
        },
      },

      toastInner: {
        exit: (toastHeight: number) => ({
          height: [toastHeight, 0],
          padding: [16, 0],
          margin: [16, 0],
          transition: {
            duration: 0.25,
            ease: 'linear',
          },
        }),
      },
    },
  } as const
}
